export default __webpack_public_path__ + "media/images/cta_blocks/set_up_events-6515f96da956d878140932afa2fab03a.jpg";